"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogHelper = void 0;
const TileType_1 = require("./TileType");
const DrawCards_1 = require("./deferredActions/DrawCards");
class LogHelper {
    static logAddResource(player, card, qty = 1) {
        let resourceType = 'resource(s)';
        if (card.resourceType) {
            resourceType = card.resourceType.toLowerCase() + '(s)';
        }
        player.game.log('${0} added ${1} ${2} to ${3}', (b) => b.player(player).number(qty).string(resourceType).card(card));
    }
    static logRemoveResource(player, card, qty = 1, effect) {
        let resourceType = 'resource(s)';
        if (card.resourceType) {
            resourceType = card.resourceType.toLowerCase() + '(s)';
        }
        player.game.log('${0} removed ${1} ${2} from ${3} to ${4}', (b) => b.player(player).number(qty).string(resourceType).card(card).string(effect));
    }
    static logTilePlacement(player, space, tileType) {
        this.logBoardTileAction(player, space, TileType_1.TileType.toString(tileType) + ' tile');
    }
    static logBoardTileAction(player, space, description, action = 'placed') {
        if (space.x === -1 && space.y === -1)
            return;
        if (player.name === 'neutral')
            return;
        const offset = Math.abs(space.y - 4);
        const row = space.y + 1;
        const position = space.x - offset + 1;
        player.game.log('${0} ${1} ${2} on row ${3} position ${4}', (b) => b.player(player).string(action).string(description).number(row).number(position));
    }
    static logColonyTrackIncrease(player, colony, steps = 1) {
        player.game.log('${0} increased ${1} colony track ${2} step(s)', (b) => b.player(player).colony(colony).number(steps));
    }
    static logTRChange(player, steps) {
        const verb = steps >= 0 ? 'gained' : 'lost';
        player.game.log('${0} ${1} ${2} TR', (b) => b.player(player).string(verb).number(steps));
    }
    static logGlobalEventTRDecrease(player, steps = 1) {
        player.game.log('${0}\'s TR decreased ${1} step(s) due to global event', (b) => b.player(player).number(steps));
    }
    static logVenusIncrease(player, steps) {
        player.game.log('${0} increased Venus scale ${1} step(s)', (b) => b.player(player).number(steps));
    }
    static logDiscardedCards(game, cards) {
        game.log('${0} card(s) were discarded', (b) => {
            b.rawString(cards.length.toString());
            for (const card of cards) {
                if (typeof card === 'string') {
                    b.cardName(card);
                }
                else {
                    b.card(card);
                }
            }
        });
    }
    static logDrawnCards(player, cards, privateMessage = false, logType = DrawCards_1.LogType.DREW) {
        const message = LogHelper.constructMessage('${0} ' + logType + ' ', cards);
        const options = privateMessage ? { reservedFor: player } : {};
        player.game.log(message, (b) => {
            privateMessage ? b.string('You') : b.player(player);
            for (const card of cards) {
                if (typeof card === 'string') {
                    b.cardName(card);
                }
                else {
                    b.card(card);
                }
            }
        }, options);
    }
    static logDraftedCards(player, draftedCards, passedCards, target) {
        let message = '${0} drafted';
        let i = 0, offset = 1;
        if (draftedCards.length === 0) {
            message += ' no cards';
        }
        else {
            for (let length = draftedCards.length; i < length; i++) {
                message += ' ${' + (i + offset) + '}';
            }
        }
        message += ', passing ';
        i = 0;
        offset += draftedCards.length;
        if (passedCards.length === 0) {
            message += 'no cards';
        }
        else {
            for (let length = passedCards.length; i < length; i++) {
                if (i > 0) {
                    if (i < length - 1) {
                        message += ', ';
                    }
                    else {
                        message += ' and ';
                    }
                }
                message += '${' + (i + offset) + '}';
            }
        }
        if (target !== undefined)
            message += ' to ${' + (i + offset) + '}';
        player.game.log(message, (b) => {
            b.string('You');
            for (const card of draftedCards) {
                b.card(card);
            }
            for (const card of passedCards) {
                b.card(card);
            }
            b.string(target);
        }, { reservedFor: player });
    }
    static logPlayerDiscardedCards(player, cards) {
        const message = LogHelper.constructMessage('You discarded ', cards);
        player.game.log(message, (b) => {
            b.string('You');
            for (const card of cards) {
                if (typeof card === 'string') {
                    b.cardName(card);
                }
                else {
                    b.card(card);
                }
            }
        }, { reservedFor: player });
    }
    static constructMessage(leadingStr, cards) {
        let message = leadingStr;
        if (cards.length === 0) {
            message += 'no cards';
        }
        else {
            for (let i = 0, length = cards.length; i < length; i++) {
                if (i > 0) {
                    if (i < length - 1) {
                        message += ', ';
                    }
                    else {
                        message += ' and ';
                    }
                }
                message += '${' + (i + 1) + '}';
            }
        }
        return message;
    }
    static logFinalScore(game, player) {
        const vpb = player.getVictoryPoints();
        let data = `Player: ${player.name}, Total: ${vpb.total}, TR: ${vpb.terraformRating}, `;
        if (game.isSoloMode() === false || game.gameOptions.automaSoloVariant) {
            data += `Milestones: ${vpb.milestones}, Awards: ${vpb.awards}, `;
        }
        data += `Greenery: ${vpb.greenery}, City: ${vpb.city}, VP: ${vpb.victoryPoints}, `;
        if (game.gameOptions.escapeVelocityMode) {
            data += `EV: ${vpb.escapeVelocity}, `;
        }
        data += `M€: ${player.megaCredits}, Time: ${player.timer.getElapsedTimeInMinutes().toFixed(2)} mins, Actions: ${player.actionsTakenThisGame}`;
        game.log(data);
    }
}
exports.LogHelper = LogHelper;
//# sourceMappingURL=LogHelper.js.map